import { ValueList } from "appworks/utils/value-list";
import { slotModel } from "slotworks/model/slot-model";
import { AgsAbstractAutoplaySliderControl } from "./ags-abstract-autoplay-slider-control";

export class AgsTotalWinLimitSliderControl extends AgsAbstractAutoplaySliderControl {
    protected getModelData(): ValueList<number> {
        return slotModel.read().autoplay.totalWinLimit;
    }

    protected saveModelData(selectedValue: number) {
        const { autoplay } = slotModel.read();
        autoplay.totalWinLimit.currentValue = selectedValue;
        autoplay.totalWinLimit.lastSelectedValue = selectedValue ?? 0;
        slotModel.write({ autoplay });
    }
}
